<template>
  <div v-inview:once.enter="checkShowForm">
    <form @submit.prevent>
      <!-- 12週間プラン -->
      <div v-if="planTwelveWeekLite">
        <!-- プラン（受講期間） -->
        <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
          <label
            class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
            for="entry_plan_id"
          >
            プラン（受講期間）
            <TeCommonBadgeRequired class="ml-2" />
          </label>
          <div class="flex basis-full flex-col items-baseline md:basis-8/12">
            <div
              v-if="showEntryStudent"
              id="entry-student"
              class="mb-2 flex gap-x-4"
            >
              <div
                v-for="(option, index) in entryStudentOptions"
                :key="index"
                class="form-control"
              >
                <label class="cursor-pointer">
                  <input
                    v-model="entryStudentSelected"
                    type="radio"
                    :value="option.value"
                    name="entry-student"
                    required
                    class="radio"
                  >
                  <span class="ml-2">{{ option.text }}</span>
                </label>
              </div>
            </div>
            <!-- 割引対象者に表示させる -->
            <TeCommonBalloon
              v-show="entryDiscountTimeLimit && isDiscount && !entryCampaign"
              id="time-limit-form"
              class="co-left mb-5 rounded border-[#ff802b] bg-[#ff802b] tracking-[.15em] text-co-yellow-500"
            >
              割引特典
              表示価格より
              <span
                id="time-limit-form-discount-price"
                class="co-display-10 font-bold"
              >
                {{ entryDiscountPrice }}</span>円引き
            </TeCommonBalloon>
            <select
              v-model="entryPlanSelected"
              class="select w-full border-2 border-co-gray-300"
              required
            >
              <option
                v-for="(option, index) in entryPlanOptions"
                :key="index"
                :value="option.value"
                :disabled="option.disabled"
              >
                {{ option.text }}
              </option>
            </select>
            <!-- キャンペーンのアラート -->
            <p
              v-show="currentPromotion && isInPromotion && isCoursePromoted"
              class="co-display-13 mb-0 mt-2"
            >
              <FontAwesomeIcon
                :icon="faBullhorn"
                class="fa-fw mr-2 inline text-[1rem] text-co-info-500"
              />
              {{ promotionTitle }}の対象プランです
            </p>
            <p
              v-show="currentPromotion && !isInPromotion && isCoursePromoted"
              class="co-display-13 mb-0 mt-2"
            >
              <FontAwesomeIcon
                :icon="faBullhorn"
                class="fa-fw mr-2 inline text-[1rem] text-co-danger-500"
              />
              {{ promotionTitle }}の対象外です
            </p>
            <!-- 4週間プラン選択時のアラート -->
            <div v-if="showReskilling && !reskillingEnabled">
              <p class="co-display-13 mb-0 mt-2">
                <FontAwesomeIcon
                  :icon="faBullhorn"
                  class="fa-fw mr-2 inline text-[1rem] text-co-danger-500"
                />
                4週間プランはリスキリング補助制度の対象外です
              </p>
            </div>
            <div v-if="showReskilling && isLitePlan">
              <p class="co-display-13 mb-0 mt-2">
                <FontAwesomeIcon
                  :icon="faBullhorn"
                  class="fa-fw mr-2 inline text-[1rem] text-co-danger-500"
                />
                Liteプランはリスキリング補助制度の対象外です
              </p>
            </div>
          </div>
        </div>
        <!-- 受講開始日 -->
        <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
          <label
            class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
            for="entry_cohort_id"
          >
            受講開始日
            <TeCommonBadgeRequired class="ml-2" />
          </label>
          <div class="basis-full md:basis-8/12">
            <select
              id="entry_cohort_id"
              v-model="entryCohortSelected"
              class="select w-full border-2 border-co-gray-300"
              required
            >
              <option
                v-for="(option, index) in entryCohortOptions"
                :key="index"
                :value="option.value"
                :disabled="option.disabled"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <!-- 12週間プラン以外 -->
      <div v-else>
        <!-- 受講開始日 -->
        <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
          <label
            class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
            for="entry_cohort_id"
          >
            受講開始日
            <TeCommonBadgeRequired class="ml-2" />
          </label>
          <div class="basis-full md:basis-8/12">
            <select
              id="entry_cohort_id"
              v-model="entryCohortSelected"
              class="select w-full border-2 border-co-gray-300"
              required
            >
              <option
                v-for="(option, index) in entryCohortOptions"
                :key="index"
                :value="option.value"
                :disabled="option.disabled"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
        <!-- プラン（受講期間） -->
        <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
          <label
            class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
            for="entry_plan_id"
          >
            プラン（受講期間）
            <TeCommonBadgeRequired class="ml-2" />
          </label>
          <div class="flex basis-full flex-col items-baseline md:basis-8/12">
            <div
              v-if="showEntryStudent"
              id="entry-student"
              class="mb-2 flex gap-x-4"
            >
              <div
                v-for="(option, index) in entryStudentOptions"
                :key="index"
                class="form-control"
              >
                <label class="cursor-pointer">
                  <input
                    v-model="entryStudentSelected"
                    type="radio"
                    :value="option.value"
                    name="entry-student"
                    required
                    class="radio"
                  >
                  <span class="ml-2">{{ option.text }}</span>
                </label>
              </div>
            </div>
            <!-- 割引対象者に表示させる -->
            <TeCommonBalloon
              v-show="entryDiscountTimeLimit && isDiscount && !entryCampaign"
              id="time-limit-form"
              class="co-left mb-5 rounded border-[#ff802b] bg-[#ff802b] tracking-[.15em] text-co-yellow-500"
            >
              割引特典
              表示価格より
              <span
                id="time-limit-form-discount-price"
                class="co-display-10 font-bold"
              >
                {{ entryDiscountPrice }}</span>円引き
            </TeCommonBalloon>
            <select
              v-model="entryPlanSelected"
              class="select w-full border-2 border-co-gray-300"
              required
            >
              <option
                v-for="(option, index) in entryPlanOptions"
                :key="index"
                :value="option.value"
                :disabled="option.disabled"
              >
                {{ option.text }}
              </option>
            </select>
            <!-- キャンペーンのアラート -->
            <p
              v-if="promotion.isVisible()"
              class="co-display-13 mb-0 mt-2"
            >
              <FontAwesomeIcon
                :icon="faBullhorn"
                class="fa-fw mr-2 inline text-[1rem]"
                :class="promotion.isCourseInPromotion(entryPlanSelected, entryCohortSelected) ? 'text-co-info-500' : 'text-co-danger-500'"
              />
              {{ promotion.title }}の{{ promotion.isCourseInPromotion(entryPlanSelected, entryCohortSelected) ? '対象プラン' : '対象外' }}です
            </p>
            <!-- 4週間プラン選択時のアラート -->
            <div v-if="showReskilling && !reskillingEnabled">
              <p class="co-display-13 mb-0 mt-2">
                <FontAwesomeIcon
                  :icon="faBullhorn"
                  class="fa-fw mr-2 inline text-[1rem] text-co-danger-500"
                />
                4週間プランはリスキリング補助制度の対象外です
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 以降は全プラン共通の要素 -->
      <!-- リスキリング補助制度 -->
      <TeCourseApplyFormReskilling
        :course-name-path="courseNamePath"
        :show-entry-reskilling="showEntryReskilling"
        :reskilling-enabled="reskillingEnabled"
        :show-is-pro-benefit-system="showIsProBenefitSystem"
        :is-lite-plan="isLitePlan"
        :errors="errors"
        @change-entry-reskilling-selected="changeEntryReskillingSelected"
      />
      <!-- 氏名 -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_last_name"
        >
          氏名
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <div class="flex gap-x-4">
            <div class="basis-6/12">
              <input
                id="entry_last_name"
                v-model="lastName"
                class="input w-full border-2 border-co-gray-300"
                placeholder="煌木"
                type="text"
                required
                @change="applyChanges"
              >
              <span
                v-if="errors.last_name && errors.last_name.length !== 0"
                class="te-invalid-feedback inline-block"
              >
                {{ errors.last_name.join(', ') }}
              </span>
            </div>
            <div class="basis-6/12">
              <input
                v-model="firstName"
                class="input w-full border-2 border-co-gray-300"
                placeholder="太郎"
                type="text"
                required
                @change="applyChanges"
              >
              <span
                v-if="errors.first_name && errors.first_name.length !== 0"
                class="te-invalid-feedback inline-block"
              >
                {{ errors.first_name.join(', ') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 氏名（カナ） -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_last_name_kana"
        >
          氏名（カナ）
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <div class="flex gap-x-4">
            <div class="basis-6/12">
              <input
                id="entry_last_name_kana"
                v-model="lastNameKana"
                placeholder="キラメキ"
                type="text"
                required
                class="input w-full border-2 border-co-gray-300"
                @change="applyChanges"
              >
              <span
                v-if="errors.last_name_kana && errors.last_name_kana.length !== 0"
                class="te-invalid-feedback inline-block"
              >
                {{ errors.last_name_kana.join(', ') }}
              </span>
            </div>
            <div class="basis-6/12">
              <input
                v-model="firstNameKana"
                placeholder="タロウ"
                type="text"
                required
                class="input w-full border-2 border-co-gray-300"
                @change="applyChanges"
              >
              <span
                v-if="errors.first_name_kana && errors.first_name_kana.length !== 0"
                class="te-invalid-feedback inline-block"
              >
                {{ errors.first_name_kana.join(', ') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- メールアドレス -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_email"
        >
          メールアドレス
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <input
            id="entry_email"
            v-model="email"
            placeholder="taro.kirameki@techacademy.jp"
            type="email"
            required
            class="input w-full border-2 border-co-gray-300"
            @change="applyChanges"
          >
          <span
            v-if="errors.email && errors.email.length !== 0"
            class="te-invalid-feedback inline-block"
          >
            {{ errors.email.join(', ') }}
          </span>
          <p class="co-display-13 mb-0 mt-2 text-co-gray-500">
            <span class="block">※できるだけPCのメールアドレスをご利用ください。</span>
            <span class="block">※携帯メールをご利用の際はドメイン指定受信の設定変更をお願いいたします。</span>
            <!-- 割引対象者に表示させる -->
            <span v-show="entryDiscountTimeLimit && isDiscount">※割引特典を利用する際には、無料相談でお申し込みされたメールアドレスをご入力ください。</span>
          </p>
        </div>
      </div>
      <!-- 電話番号 -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_tel"
        >
          電話番号
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <input
            id="entry_tel"
            v-model="tel"
            placeholder="09012345678（ハイフン不要）"
            type="tel"
            required
            class="input w-full border-2 border-co-gray-300"
            @change="applyChanges"
          >
          <span
            v-if="errors.tel && errors.tel.length !== 0"
            class="te-invalid-feedback inline-block"
          >
            {{ errors.tel.join(', ') }}
          </span>
        </div>
      </div>
      <!-- 生年月日 -->
      <div
        v-if="entryStudentSelected === '1' || showBirthday"
        class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8"
      >
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_birthday"
        >
          生年月日
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <div class="flex gap-x-1">
            <select
              id="entry_birthday"
              v-model="birthdayYearSelected"
              class="select w-auto border-2 border-co-gray-300"
              required
              @change="applyChanges"
            >
              <option
                v-for="(option, index) in birthdayYearOptions"
                :key="index"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <select
              v-model="birthdayMonthSelected"
              class="select w-auto border-2 border-co-gray-300"
              required
              @change="applyChanges"
            >
              <option
                v-for="(option, index) in birthdayMonthOptions"
                :key="index"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <select
              v-model="birthdayDaySelected"
              class="select w-auto border-2 border-co-gray-300"
              required
              @change="applyChanges"
            >
              <option
                v-for="(option, index) in birthdayDayOptions"
                :key="index"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <span
              v-if="errors.birthday && errors.birthday.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.birthday.join(', ') }}
            </span>
          </div>
          <div
            v-show="entryUserAge < 20 && !showEntryStudent"
            id="js-age-validation"
            class="alert mb-0 mt-4 rounded border-[#ffeeba] bg-[#fff3cd] text-[#856404]"
          >
            <FontAwesomeIcon
              :icon="faTriangleExclamation"
              class="fa-fw inline pr-2"
            />
            動画広告クリエイターコースは受講開始時点で20歳以上の方のみご受講いただけます。
          </div>
          <div
            v-if="showEntryStudent && entryUserAge < 18"
            id="js-parental-consent-validation"
            class="pt-5"
          >
            <label class="label cursor-pointer justify-start gap-x-2">
              <input
                v-model="parentalStatus"
                type="checkbox"
                class="checkbox checkbox-xs"
              >
              <span class="co-display-13 label-text">親権者の了承を得ている</span>
            </label>
          </div>
        </div>
      </div>
      <!-- 備考 -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_remarks"
        >
          備考
          <TeCommonBadgeOptional class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <input
            id="entry_remarks"
            v-model="remarks"
            type="text"
            class="input w-full border-2 border-co-gray-300"
            @change="applyChanges"
          >
          <p class="co-display-13 mt-1">
            <span
              v-show="!!entryCampaign && isDiscount"
              class="block text-co-gray-500"
            >※ 無料相談の割引特典をご利用される方はこちらにキャンペーンコードをご入力ください。</span>
            ご質問いただいてもご返信差し上げることができません。<br>
            お申し込み後にお問い合わせフォームからご質問ください。
          </p>
        </div>
      </div>

      <!-- ボタン -->
      <div class="flex flex-col justify-end pb-5 pt-4 md:flex-row">
        <div class="basis-full md:ml-auto md:basis-8/12 md:pl-6">
          <div
            v-if="showEntryStudent && entryUserAge < 18 && parentalStatus === false"
            id="validation-msg"
            class="pb-5 text-co-danger-500"
          >
            生年月日の欄にある「親権者の了承を得ている」にチェックが必要です
          </div>
          <span
            v-if="Object.keys(errors).length !== 0"
            class="te-invalid-feedback inline-block py-2"
          >
            入力いただいた情報に誤りまたは不足があるようです。
          </span>
          <span
            v-if="applicationErrors.length !== 0"
            class="te-invalid-feedback inline-block py-2"
          >
            {{ applicationErrors[0] }}
          </span>
          <!-- 申し込み内容を確認するボタン -->
          <button
            :disabled="isEntryDisabled"
            class="co-btn-submit-stretch"
            @click="onSubmit(false)"
          >
            申し込み内容を確認する
          </button>
        </div>
      </div>
    </form>

    <!-- お申し込み内容の確認モーダル -->
    <client-only>
      <Teleport to="body">
        <dialog
          ref="applyModal"
          class="modal"
        >
          <div class="modal-box">
            <!-- 右上の閉じるボタン -->
            <button
              class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
              @click="closeModal"
            >
              ✕
            </button>
            <!-- モーダルのコンテンツ -->
            <div class="te-modal-body">
              <TeCourseConfirmForm
                v-if="confirmationItems"
                :last-name="lastName"
                :first-name="firstName"
                :last-name-kana="lastNameKana"
                :first-name-kana="firstNameKana"
                :email="email"
                :tel="tel"
                :birthday="getBirthday()"
                :course="course"
                :cohort="entryCohort"
                :closes-before-day="closesBeforeDay"
                :entry-plan-title="entryPlanTitle"
                :remarks="remarks"
                :is-pro-benefit-system="showIsProBenefitSystem ? isProBenefitSystem : null"
                :is-reskilling="showReskilling ? isReskilling : null"
                :promotion="isInPromotion ? currentPromotion.attributes.title : null"
                :confirmation-items="confirmationItems"
                :course-name-path="courseNamePath"
                :show-entry-reskilling="showEntryReskilling"
              />
              <!-- モーダルフッター -->
              <div class="modal-action absolute inset-x-0 bottom-0 mt-0 flex w-full justify-between border-t border-co-gray-200 p-4 backdrop-blur md:justify-around">
                <button
                  class="co-btn-tertiary"
                  @click="closeModal"
                >
                  修正する
                </button>
                <button
                  class="co-btn-submit !w-auto !px-3 !py-1 !text-[1rem]"
                  @click="onSubmit(true)"
                >
                  申し込みを確定する
                </button>
              </div>
            </div>
          </div>
          <!-- モーダルの外側をクリックしたら閉じる -->
          <button
            class="modal-backdrop"
            @click="closeModal"
          >
            close
          </button>
        </dialog>
      </Teleport>
    </client-only>
  </div>
</template>

<script lang="ts">
import {
  postCourseEntry,
  getPromotionCohorts,
  getPromotionPlans,
} from '~/utility/fetchAPI'
import {
  yearOptions,
  monthOptions,
  dayOptions,
  formatDate,
  getAdItem,
} from '~/utility/utility'
import validateApplyForm from '~/utility/validation/validateApplyForm'
import validateReskillingApplyForm from '~/utility/validation/validateReskillingApplyForm'
import TeCommonBadgeRequired from '~/components/Te/TeCommon/Badge/TeCommonBadgeRequired/TeCommonBadgeRequired.vue'
import TeCommonBadgeOptional from '~/components/Te/TeCommon/Badge/TeCommonBadgeOptional/TeCommonBadgeOptional.vue'
import TeCommonBalloon from '~/components/Te/TeCommon/Balloon/TeCommonBalloon/TeCommonBalloon.vue'
import TeCourseApplyFormReskilling from '~/components/Te/TeCourse/TeCourseApplyFormReskilling.vue'
import TeCourseConfirmForm from '~/components/Te/TeCourse/TeCourseConfirmForm.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBullhorn, faTriangleExclamation } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface TextValue {
  value: string
  text: string
  disabled?: boolean
}

interface Data {
  email: string
  lastName: string
  lastNameKana: string
  firstName: string
  firstNameKana: string
  entryCohortSelected: string
  tel: string
  birthday: string
  remarks: string
  entryStudentSelected: string
  entryPlanSelected: string
  birthdayYearSelected: string
  birthdayYearOptions: TextValue[]
  birthdayMonthSelected: string
  birthdayMonthOptions: TextValue[]
  birthdayDaySelected: string
  birthdayDayOptions: TextValue[]
  parentalStatus: Boolean
  errors: any
  applicationErrors: string[]
  promotionCohorts: number[]
  promotionPlans: number[]
  confirmationItems: null | object
  entryReskillingSelected: string
  isProBenefitSystem: boolean
  isReskilling: boolean
}

interface Methods {
  formatDate: (date: Date, format: string) => string
  onSubmit: (isPersist: boolean) => void
  checkShowForm: () => void
  selectedPlanOption: () => TextValue
  applyChanges: () => void
  getBirthday: () => Date | null
  changeEntryReskillingSelected: (selected: string) => void
}

interface Computed {
  entryCohorts: any
  entryCohortOptions: TextValue[]
  entryPlanOptions: TextValue[] | null
  entryStudentOptions: TextValue[]
  isInPromotion: boolean
  isDiscount: boolean
  litePlanId: string | null
  isLitePlan: boolean
  entryDiscountPrice: '5,000' | '10,000'
  entryUserAge: number
  showEntryStudent: boolean
  showBirthday: boolean
  showIsProBenefitSystem: boolean
  isEntryDisabled: boolean
  entryPlanWeek: number | null
  entryPlanTitle: string | null
  proBenefitSystemEnabled: boolean
  closesBeforeDay: Date
  entryCohort: object
  showEntryReskilling: boolean
  showReskilling: boolean
  reskillingEnabled: boolean
  promotionTitle: string
  isCoursePromoted: boolean
}


const cohortToTextValue = (
  cohort: any,
  config: {
    sakiwari: Boolean
    latest: Boolean
  }
): TextValue => {
  const cohortName = cohort.attributes.display_title_for_plan
  const cohortId = cohort.id
  if (config.sakiwari) {
    const cohortTextValue: TextValue = {
      value: cohortId,
      text: `【先割】 ${cohortName}`,
    }
    return cohortTextValue
  } else if (config.latest) {
    const cohortTextValue: TextValue = {
      value: cohortId,
      text: `【締切間近】 ${cohortName}`,
    }
    return cohortTextValue
  } else {
    const cohortTextValue: TextValue = { value: cohortId, text: cohortName }
    return cohortTextValue
  }
}

const options = {
  async setup(props: any, ctx: any) {
    const route = useRoute()
    const { $criteoEvent: criteoEvent }  = useNuxtApp()
    const isShowForm = ref(false)

    // モーダルの開閉制御
    const applyModal = ref<HTMLDialogElement | null>(null)

    const showModal = () => {
      if (applyModal.value) {
        applyModal.value.showModal();
      }
    };

    const closeModal = () => {
      if (applyModal.value) {
        applyModal.value.close();
      }
    };

    // 離脱防止アラート
    const isBlocked = ((): undefined | globalThis.Ref<boolean> => {
      if (import.meta.server) { return }

      const isBlockedRef = useBeforeunloadBlock().isBlocked

      // /briefing 以外のページではisBlockedをfalseに設定
      if (!route.path.startsWith('/briefing')) {
        isBlockedRef.value = false;
      }

      return isBlockedRef
    })()

    const promotion = usePromotion('course', props.courseNamePath)
    return {
      route,
      applyModal,
      showModal,
      closeModal,
      criteoEvent,
      isShowForm,
      isBlocked,
      faBullhorn,
      faTriangleExclamation,
      promotion,
    }
  },
  props: {
    cohorts: {
      type: Array,
      default: () => [],
    },
    latestCohort: {
      default: null,
    },
    sakiwariCohorts: {
      type: Array,
      default: () => [],
    },
    course: {
      type: Object,
      default: null,
    },
    currentPromotion: {
      type: Object,
    },
    courseNamePath: {
      type: String,
    },
    entryDiscountTimeLimit: {
      default: null,
    },
    entryCampaign: {
      type: Object,
      default: null,
    },
    windowBlock: {
      default: false,
    },
    planTwelveWeekLite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lastName: '',
      firstName: '',
      lastNameKana: '',
      firstNameKana: '',
      email: '',
      tel: '',
      birthday: '',
      remarks: '',
      entryCohortSelected: '',
      entryStudentSelected: '0',
      entryPlanSelected: '',
      birthdayYearSelected: '1991',
      birthdayYearOptions: yearOptions,
      birthdayMonthSelected: '5',
      birthdayMonthOptions: monthOptions,
      birthdayDaySelected: '27',
      birthdayDayOptions: dayOptions,
      parentalStatus: false,
      errors: {},
      applicationErrors: [],
      promotionCohorts: [],
      promotionPlans: [],
      confirmationItems: null,
      entryReskillingSelected: '', // リスキリング補助制度、ラジオボタンの初期状態を空にする
      isProBenefitSystem: false,
      isReskilling: false,
      waitCourseIntervalId: null,
    }
  },
  async mounted() {
    getPromotionCohorts(this.$api, this.courseNamePath).then((response) => {
      this.promotionCohorts = response.data
    })

    getPromotionPlans(this.$api, this.courseNamePath).then((response) => {
      this.promotionPlans = response.data
    })
  },
  watch: {
    // 学生・社会人の切り替え時にプラン選択をリセット
    entryStudentSelected() {
      this.entryPlanSelected = ''
    },
  },
  computed: {
    entryCohorts() {
      if (this.cohorts) {
        return this.cohorts.concat(this.sakiwariCohorts)
      } else {
        return this.sakiwariCohorts
      }
    },
    entryCohortOptions() {
      if (this.entryCohorts.length !== 0 && this.cohorts) {
        const selectedPlan = this.selectedPlanOption()
        const options: TextValue[] = []

        this.cohorts.forEach((cohort: any, index: number) => {
          const option = cohortToTextValue(cohort, {
            sakiwari: false,
            latest: index === 0,
          })
          options.push(option)

          // 初期値設定
          if (this.entryCohortSelected === '' && index === 0) {
            this.entryCohortSelected = option.value
          }
        })
        this.sakiwariCohorts.forEach((cohort: any) => {
          const option = cohortToTextValue(cohort, {
            sakiwari: true,
            latest: false,
          })
          const disabled =
            selectedPlan.text.includes('Lite') ||
            selectedPlan.text.includes('4週間') ||
            selectedPlan.text.includes('8週間')
          Object.assign(option, { disabled })
          options.push(option)
        })

        return options
      } else {
        return [{ value: '0', text: '読み込み中' }]
      }
    },
    entryPlanOptions() {
      if (this.entryCohorts.length === 0)
        return [{ value: '0', text: '読み込み中' }]
      const selectedCohort = this.entryCohorts.find((cohort: any) => {
        return cohort.id === this.entryCohortSelected
      })
      if (!selectedCohort) return [{ value: '0', text: '読み込み中' }]

      const plans: Object[] =
        this.entryStudentSelected === '0'
          ? selectedCohort.attributes.collection_for_plans
          : selectedCohort.attributes.collection_for_stundent_plans
      const options: TextValue[] = plans.map((plan: any) => {
        const disabled = !!(
          (plan[0].includes('Lite') &&
            (this.sakiwariCohorts.includes(selectedCohort) ||
              this.isReskilling)) ||
          (plan[0].includes('4週間') &&
            this.courseNamePath !== 'ordermade' &&
            (this.isProBenefitSystem || this.isReskilling)) ||
          (plan[0].includes('8週間') &&
            (this.courseNamePath === 'first-sidejob-oneonone-plan') &&
            this.sakiwariCohorts.includes(selectedCohort)) ||
          (this.courseNamePath === 'ai' &&
            (plan[0].includes('12週間') || plan[0].includes('16週間')) &&
            this.isProBenefitSystem) ||
          (this.courseNamePath === 'datascience' &&
            plan[0].includes('12週間') &&
            this.isProBenefitSystem)
        )

        return { value: plan[1], text: plan[0], disabled }
      })

      // 初期値設定
      const selectedOption: any = options.find((option: any) => {
        return option.value === this.entryPlanSelected
      })
      if (
        this.entryPlanSelected === '' ||
        !options
          .map(function (o) {
            return o.value
          })
          .includes(this.entryPlanSelected) ||
        (selectedOption && selectedOption.disabled)
      ) {
        // disabledは初期値にしない
        const undisabledOption = options.find((option: any) => {
          return !option.disabled
        })
        this.entryPlanSelected =
          (undisabledOption && undisabledOption.value) ||
          (options[0] && options[0].value)
      }
      return options
    },
    entryStudentOptions() {
      return [
        { text: '社会人', value: '0' },
        { text: '学生', value: '1', disabled: this.isProBenefitSystem },
      ]
    },
    isInPromotion() {
      if (this.course && this.currentPromotion) {
        const selectedPlan = Object.values(this.course.attributes.plans).find(
          (plan: any) => {
            return Number(plan.id) === Number(this.entryPlanSelected)
          }
        ) as any
        if (selectedPlan) {
          if (this.promotionPlans.includes(Number(this.entryPlanSelected))) {
            if (
              this.promotionCohorts.includes(Number(this.entryCohortSelected))
            ) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isDiscount() {
      if (this.sakiwariCohorts) {
        return !this.sakiwariCohorts.find(
          (cohort: any) => cohort.id === this.entryCohortSelected
        )
      } else {
        return true
      }
    },
    litePlanId() {
      if (!this.entryPlanOptions) {
        return null
      }
      // entryPlanOptionsの中でnameに「Lite」が入っているものを探す
      const litePlan = this.entryPlanOptions.find((plan: any) => {
        return plan.text.includes('Lite')
      })
      return litePlan ? litePlan.value : null
    },
    isLitePlan() {
      return !!(this.litePlanId && this.entryPlanSelected === this.litePlanId)
    },
    entryDiscountPrice() {
      if (this.entryStudentSelected === '0' || this.isLitePlan) {
        return '10,000'
      } else {
        return '5,000'
      }
    },
    entryUserAge() {
      // 誕生年月日
      const birthday = new Date(
        Number(this.birthdayYearSelected),
        Number(this.birthdayMonthSelected) - 1,
        Number(this.birthdayDaySelected)
      )
      const today = new Date()

      // 今年の誕生日
      const thisYearBirthday = new Date(
        today.getFullYear(),
        birthday.getMonth(),
        birthday.getDate()
      )
      let age = today.getFullYear() - birthday.getFullYear()
      age = today < thisYearBirthday ? age - 1 : age
      return age
    },
    showEntryStudent() {
      if (this.entryCohortSelected) {
        const selectedCohort = this.entryCohorts.find((cohort: any) => {
          return cohort.id === this.entryCohortSelected
        })
        if (
          selectedCohort.attributes.collection_for_stundent_plans.length === 0
        ) {
          return false
        }
      }
      return ![
        'video-ad',
        'webdesign-freelance',
        'front-freelance',
        'node-js',
        'blockchain',
        'scala',
        'blockchain-basic',
        'scratch',
        'videoediting',
        'gas',
        'jobchange',
        'video-ad',
        'iphone',
        'android',
        'unity',
        'oss',
        'first-dx',
        'dx-management',
        'rails-portfolio',
        'frontend-sidejob',
        'design-portfolio',
        'first-prompt-eng',
        'llm-dev',
        'web-practice',
        'first-sidejob-oneonone-plan'
      ].includes(this.courseNamePath)
    },
    showBirthday() {
      return ['video-ad'].includes(this.courseNamePath)
    },
    showIsProBenefitSystem() {
      return (
        ['ai', 'datascience'].includes(this.courseNamePath) &&
        this.entryStudentSelected === '0' &&
        this.proBenefitSystemEnabled
      )
    },
    isEntryDisabled() {
      return (
        (this.showEntryStudent &&
          this.entryUserAge < 18 &&
          this.parentalStatus === false) ||
        (this.showBirthday && this.entryUserAge < 20)
      )
    },
    entryPlanWeek() {
      if (this.entryPlanSelected && this.course) {
        if (this.isLitePlan) {
          return 12
        }
        const plan = Object.values(this.course.attributes.plans).find(
          (plan: any) => {
            return plan.id === this.entryPlanSelected
          }
        ) as any
        return plan.weeks
      }
    },
    entryPlanTitle() {
      let entryStudent = ''
      if (this.showEntryStudent && this.entryStudentSelected) {
        entryStudent = Object.values(this.entryStudentOptions).find(
          (option: any) => {
            return Number(option.value) === Number(this.entryStudentSelected)
          }
        )!.text
      }

      let planTitle = ''
      if (this.entryPlanSelected) {
        planTitle = this.entryPlanOptions!.find((option: any) => {
          return Number(option.value) === Number(this.entryPlanSelected)
        })!.text.split('（')[0]
      }

      return [entryStudent, planTitle].join(' ')
    },
    proBenefitSystemEnabled() {
      return (
        !(this.courseNamePath === 'ai' && this.entryPlanWeek !== 8) &&
        !(
          this.courseNamePath === 'datascience' &&
          this.entryPlanWeek !== 8 &&
          this.entryPlanWeek !== 16
        ) &&
        !!(this.entryPlanWeek !== 4)
      )
    },
    reskillingEnabled() {
      return !!(this.courseNamePath === 'ordermade' || this.entryPlanWeek !== 4)
    },
    closesBeforeDay() {
      const date = new Date(this.latestCohort.attributes.closes_at)
      date.setDate(date.getDate() - 1)
      return date
    },
    entryCohort() {
      return this.entryCohorts
        .concat(this.sakiwariCohorts)
        .find(
          (cohort: any) =>
            Number(cohort.id) === Number(this.entryCohortSelected)
        )
    },
    // リスキリング補助制度：通常コース
    showEntryReskilling() {
      return [
        'first-sidejob-oneonone-plan',
        'webdesign',
        'frontend',
        'python',
        'java-servlet',
        'web-practice',
        'ai',
        'datascience',
      ].includes(this.courseNamePath)
    },
    showReskilling() {
      return this.showEntryReskilling
    },
    promotionTitle() {
      return this.currentPromotion ? this.currentPromotion.attributes.title : ''
    },
    isCoursePromoted() {
      return this.currentPromotion
        ? this.currentPromotion.attributes.screen_names.includes(
            this.courseNamePath
          )
        : false
    },
  },
  methods: {
    formatDate(date: Date, format: string) {
      return formatDate(date, format)
    },

    getBirthday() {
      let date = null

      if (this.entryStudentSelected === '1' || this.showBirthday) {
        date = new Date(
          Number(this.birthdayYearSelected),
          Number(this.birthdayMonthSelected) - 1,
          Number(this.birthdayDaySelected)
        )
      }

      return date
    },
    applyChanges() {
      // @ts-ignore
      this.isBlocked = true
    },
    selectedPlanOption() {
      const options = this.entryPlanOptions || []
      const entryPlanOption = options.find((option: any) => {
        return option.value === this.entryPlanSelected
      })
      return entryPlanOption || { value: '0', text: '読み込み中' }
    },
    checkShowForm() {
      this.waitCourseIntervalId = setInterval(() => {
        if (this.course?.id) {
          this.criteoEvent(String(this.course?.id), getAdItem(this.course))
          clearInterval(this.waitCourseIntervalId)
        }
      }, 5000)
    },
    onSubmit(isPersist = false) {
      this.errors = {}
      this.applicationErrors = []
      const body: any = {
        entry: {
          cohort_id: this.entryCohortSelected,
          plan_id: this.entryPlanSelected,
          student: this.entryStudentSelected,
          email: this.email,
          last_name: this.lastName,
          last_name_kana: this.lastNameKana,
          first_name: this.firstName,
          first_name_kana: this.firstNameKana,
          reskilling: this.entryReskillingSelected, // validation用
          is_pro_benefit_system: this.isProBenefitSystem,
          is_reskilling: this.isReskilling,
          tel: this.tel,
          remarks: this.remarks,
          marketing_params: this.$marketingParams.get(),
        },
      }
      if (this.entryStudentSelected === '1' || this.showBirthday) {
        body.entry.birthday = `${this.birthdayYearSelected}-${this.birthdayMonthSelected}-${this.birthdayDaySelected}`
      }

      let validateForm = validateApplyForm
      // リスキリングの時はバリデーションを変える
      if (this.showReskilling) {
        validateForm = validateReskillingApplyForm
      }

      validateForm(body)
        .then(() => {
          delete body.entry.reskilling
          postCourseEntry(this.$api, this.courseNamePath, body, isPersist)
            .then((data) => {
              if (isPersist) {
                // @ts-ignore
                this.isBlocked = false
                this.$marketingParams.remove()
                window.location.href = `/courses/${this.courseNamePath}/entries/completed`
              } else {
                this.confirmationItems = data
                this.applyModal.showModal()
              }
            })
            .catch((errors) => {
              this.applicationErrors = errors?.response?.data?.errors
            })
        })
        .catch((errors: any) => {
          this.errors = errors
        })
    },
    changeEntryReskillingSelected(selected: string) {
      this.entryReskillingSelected = selected
      this.isReskilling = selected === '0'
    },
  },
  components: {
    TeCommonBadgeRequired,
    TeCommonBadgeOptional,
    TeCommonBalloon,
    TeCourseApplyFormReskilling,
    TeCourseConfirmForm,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-invalid-feedback {
  width: 100%;
  margin-top: .25rem;
  font-size: .875em;
  color: #dc3545;
}
</style>
